/**
 * AccentCard — a card on the warm yellow tint, with a badge-and-title header.
 *
 * The checkout "Delivery date" and "Delivery details" blocks are the two the
 * student must actually read and act on, so they sit on the brand tint while
 * the rest of the page stays on white. Making them the odd ones out is the
 * whole point — a page where everything is highlighted highlights nothing.
 *
 * It exists as a component rather than a copied set of classes so the tint,
 * the border and the badge are defined ONCE. Two hand-copied card shells drift
 * the first time someone nudges the shade on one of them.
 *
 * Content is left entirely to the caller: one card holds read-only rows, the
 * other holds form fields, and they should not be forced into a shared shape.
 */

import { cn } from '@/lib/cn';

export function AccentCard({ icon: Icon, title, children, className }) {
  return (
    <section
      aria-label={title}
      className={cn('mt-4 rounded-2xl border border-accent-200 bg-accent-100/60 p-4', className)}
    >
      <div className="mb-3 flex items-center gap-2.5">
        <span className="grid h-8 w-8 shrink-0 place-items-center rounded-xl bg-accent-500 text-white">
          <Icon size={18} />
        </span>
        <h2 className="text-base font-bold text-ink">{title}</h2>
      </div>
      {children}
    </section>
  );
}

export default AccentCard;
